import { motion } from "framer-motion";

export default function M2TInterlinkDiagram() {
  const hubs = [
    { label: "Connect", color: "#6366f1" },
    { label: "Trade", color: "#22c55e" },
    { label: "Learn", color: "#facc15" },
    { label: "Earn", color: "#3b82f6" },
    { label: "Build", color: "#a21caf" },
    { label: "Launch", color: "#f59e42" },
  ];
  const users = Array.from({ length: 8 }).map((_, i) => ({ label: `U${i + 1}` }));

  const centerX = 300, centerY = 300;
  const userRadius = 100, hubRadius = 180, aiRadius = 65;

  return (
    <div className="flex justify-center items-center py-4">
      <motion.svg
        viewBox="0 0 600 600"
        className="w-full max-w-[340px] sm:max-w-[480px] md:max-w-[600px] h-auto block mx-auto"
        animate={{
          filter: [
            "brightness(1)",
            "brightness(1)",
            "brightness(2)",
            "brightness(1)",
          ],
        }}
        transition={{
          duration: 3,
          times: [0, 0.96, 0.98, 1],
          ease: "linear",
          repeat: Infinity
        }}
      >
        {/* Glowing blue AI engine ring */}
        <circle
          cx={centerX} cy={centerY} r={aiRadius}
          fill="none"
          stroke="#38bdf8"
          strokeWidth={6}
          opacity={0.6}
        />

        {/* User-to-user mesh */}
        {users.map((userA, i) =>
          users.map((userB, j) =>
            i < j && (
              <line
                key={`${i}-${j}`}
                x1={centerX + userRadius * Math.cos((2 * Math.PI * i) / users.length)}
                y1={centerY + userRadius * Math.sin((2 * Math.PI * i) / users.length)}
                x2={centerX + userRadius * Math.cos((2 * Math.PI * j) / users.length)}
                y2={centerY + userRadius * Math.sin((2 * Math.PI * j) / users.length)}
                stroke="#cbd5e1"
                strokeWidth="1"
                opacity="0.25"
              />
            )
          )
        )}

        {/* User-to-hub links */}
        {users.map((user, ui) =>
          hubs.map((hub, hi) => (
            <line
              key={`user-hub-${ui}-${hi}`}
              x1={centerX + userRadius * Math.cos((2 * Math.PI * ui) / users.length)}
              y1={centerY + userRadius * Math.sin((2 * Math.PI * ui) / users.length)}
              x2={centerX + hubRadius * Math.cos((2 * Math.PI * hi) / hubs.length)}
              y2={centerY + hubRadius * Math.sin((2 * Math.PI * hi) / hubs.length)}
              stroke={hub.color}
              strokeWidth="2"
              opacity="0.7"
            />
          ))
        )}

        {/* User nodes */}
        {users.map((user, i) => (
          <g key={user.label}>
            <circle
              cx={centerX + userRadius * Math.cos((2 * Math.PI * i) / users.length)}
              cy={centerY + userRadius * Math.sin((2 * Math.PI * i) / users.length)}
              r="19"
              fill="#fff"
              stroke="#64748b"
              strokeWidth="3"
            />
            <text
              x={centerX + userRadius * Math.cos((2 * Math.PI * i) / users.length)}
              y={centerY + userRadius * Math.sin((2 * Math.PI * i) / users.length) + 7}
              textAnchor="middle"
              fontSize="13"
              fontWeight="bold"
              fill="#64748b"
            >
              {user.label}
            </text>
          </g>
        ))}

        {/* Hub nodes */}
        {hubs.map((hub, i) => (
          <g key={hub.label}>
            <circle
              cx={centerX + hubRadius * Math.cos((2 * Math.PI * i) / hubs.length)}
              cy={centerY + hubRadius * Math.sin((2 * Math.PI * i) / hubs.length)}
              r="38"
              fill={hub.color}
              filter="url(#hubShadow)"
            />
            <text
              x={centerX + hubRadius * Math.cos((2 * Math.PI * i) / hubs.length)}
              y={centerY + hubRadius * Math.sin((2 * Math.PI * i) / hubs.length) + 7}
              textAnchor="middle"
              fontSize="18"
              fontWeight="bold"
              fill="#fff"
              style={{ textShadow: "0 2px 12px #111" }}
            >
              {hub.label}
            </text>
          </g>
        ))}
        {/* SVG filter for subtle shadow */}
        <defs>
          <filter id="hubShadow" x="0" y="0" width="200%" height="200%">
            <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor="#000" floodOpacity="0.4" />
          </filter>
        </defs>

        {/* AI text, big and clear */}
        <text
          x={centerX}
          y={centerY + 12}
          textAnchor="middle"
          fontSize="42"
          fontWeight="900"
          fill="#fff"
          stroke="#38bdf8"
          strokeWidth="2.2"
          style={{
            textShadow: "0 0 18px #38bdf8, 0 2px 8px #000",
            letterSpacing: "4px",
          }}
        >
          AI
        </text>
        {/* "Engine" label below AI */}
        <text
          x={centerX}
          y={centerY + 38}
          textAnchor="middle"
          fontSize="18"
          fontWeight="bold"
          fill="#facc15"
          style={{ letterSpacing: "1.2px", textShadow: "0 0 8px #fff" }}
        >
          Engine
        </text>
      </motion.svg>
    </div>
  );
}
